import Vue from 'vue';
import slideDialog from '@/views/aiAgent/component/dialog/slideDialog.vue';

const ConfirmConstructor = Vue.extend(slideDialog);

function confirmDialog(message = '', title = '', options = {}) {
  return new Promise((resolve, reject) => {
    const instance = new ConfirmConstructor({
      propsData: {
        title: title || options.title || '提示',
        width: options.width || '400px',
        modelValue: false, // 关键：初始为 false（先挂载再打开）
        showFooter: options.showFooter || true,
        message: message || '',
        iconClass: options.iconClass || 'el-icon-info',
        type: options.type || 'info',
        confirmButtonText: options.confirmButtonText || '确 定',
        cancelButtonText: options.cancelButtonText || '取 消',
        withHtml: options.withHtml || false,
      }
    }).$mount(); // 生成 $el，但还未插入 DOM

    // 把组件插入页面
    document.body.appendChild(instance.$el);

    let handled = false;
    instance.$on('update:modelValue', val => {
      instance.modelValue = val
    })
    // 当用户点击确认（组件内部会 emit 'confirm' 然后触发 closeDialog）
    instance.$on('confirm', () => {
      handled = true;
      resolve({
        setLoading: (val) => instance.loading = val,
        close: () => { instance.$emit("update:modelValue", false); }
      }); // 业务侧的 then 会执行
      // 不立即销毁，等 after-leave -> 'closed' 事件再清理
    });

    // 监听组件在 leave 动画结束后触发的 'closed' 事件
    instance.$on('close', () => {
      // 清理 DOM / destroy
      Vue.nextTick(()=>{
        if (instance.$el && instance.$el.parentNode) {
          instance.$el.parentNode.removeChild(instance.$el);
        }
        instance.$destroy();
      })

      // 如果用户只是关闭/取消（没有 confirm），则 reject
      if (!handled) reject();
    });

    // 打开（append 后再打开，才能触发 enter 动画）
    Vue.nextTick(() => {
      instance.modelValue = true;
    });
  }).catch(e => {
    return Promise.reject(e);
  });
}

// 挂载到 Vue prototype，这样全局组件可直接 this.$confirm(...)
Vue.prototype.$confirmDialog = confirmDialog;

export default confirmDialog;
